/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { MerchantRoleList } from '../../../config/roles';



export default function MerchantRoleSelection({ selected, handleSelection, error, handleValidation, state, setstate, checkedRoles, setCheckedRoles, employee }) {
    const [activeAccordion, setActiveAccordion] = useState(null);

    // const toggleAccordion = (index) => {
    //     setActiveAccordion(activeAccordion === index ? null : index);
    // };
    const [openStates, setOpenStates] = useState(Array(Object.keys(MerchantRoleList).length).fill(false));
    // const [checkedRoles, setCheckedRoles] = useState({});
    const [selectedMerchantAll, setSelectedMerchantAll] = useState(false);
    // const toggleAccordion = (index) => {
    //     setOpenStates(prevStates => {
    //         const newState = [...prevStates];
    //         newState[index] = !newState[index];
    //         return newState;
    //     });
    // };

    const toggleAccordion = (index) => {
        setOpenStates(prevStates => {
            const newState = prevStates.map((state, idx) => idx === index ? !state : false);
            return newState;
        });
    };


    function compareSelected(selected) {
        // Loop through each key in MerchantRoleList
        for (let role in MerchantRoleList) {
            // If the role key from MerchantRoleList is not present in selected, return false
            if (!selected.hasOwnProperty(role)) {
                return false;
            }
            // Loop through each permission in the role
            for (let permission of MerchantRoleList[role]) {
                // If the permission key from MerchantRoleList is not present in selected, return false
                if (!selected[role].hasOwnProperty(permission)) {
                    return false;
                }
            }
        }
        // If all keys and permissions are present, return true
        return true;
    }
    function getKeysBefore(obj, key) {

        const keysBefore = [];
        for (const mainrole in obj) {
            const roles = obj[mainrole];
            const index = roles.indexOf(key);
            if (index > 0) {
                keysBefore.push(...roles.slice(0, index));
            }
        }
        return keysBefore;
    }

    function getKeysAfter(obj, key) {
        const keysAfter = [];
        for (const mainrole in obj) {
            const roles = obj[mainrole];
            const index = roles.indexOf(key);
            if (index >= 0 && index < roles.length - 1) {
                keysAfter.push(...roles.slice(index + 1));
            }
        }
        return keysAfter;
    }

    const handleMainCheckboxChange = (mainrole, role) => {
        if (role) {
            const isChecked = !checkedRoles[mainrole]?.[role];
            if (!isChecked) {
                let updatedCheckedRoles = { ...checkedRoles }
                const previousKeys = getKeysBefore(MerchantRoleList, role)
                const afterKeys = getKeysAfter(MerchantRoleList, role)
                if (mainrole === 'Manage Templates') {
                    if (role === 'SMS_template_list' || role === 'email_template_list'){
                        if(role === 'SMS_template_list'){
                            if (afterKeys.length > 0) {
                                afterKeys.map((key, i) => {
                                    if(key.includes('SMS')){
                                        delete updatedCheckedRoles[mainrole][key];
                                    }
                                })
                            }
                        }else{
                            if (afterKeys.length > 0) {
                                afterKeys.map((key, i) => {
                                    if(key.includes('email')){
                                        delete updatedCheckedRoles[mainrole][key];
                                    }
                                })
                            }
                        }
                        delete updatedCheckedRoles[mainrole][role]
                        if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                            delete updatedCheckedRoles[mainrole];
                        }
                        setCheckedRoles({ ...updatedCheckedRoles })
                        return;
                    }
                }else{
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role.includes('list')) {
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role === 'change_support_ticket_status' || role === 'change_settlement_status') {
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role === 'view_support_request' || role === 'view_settlement') {
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                if (role.includes('activate_or_deactivate') || role.includes('change_store_customization')) {
                    // if (afterKeys.length > 0) {
                    //     afterKeys.map((key,i) => {
                    //         delete updatedCheckedRoles[mainrole][key];
                    //     })
                    // }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                //this condition if for manage products where view product must be checked if the delete product is checked.
                if (role === 'view_product' || role === 'view_reserved_product') {
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            if (key !== 'ready_to_collect' && key !== 'cancel_reservation')
                                delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                //this condition if for manage carts where view product must be checked if the after keys are checked.
                if (role === 'view_cart') {
                    if (afterKeys.length > 0) {
                        afterKeys.map((key, i) => {
                            delete updatedCheckedRoles[mainrole][key];
                        })
                    }
                    delete updatedCheckedRoles[mainrole][role]
                    if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                        delete updatedCheckedRoles[mainrole];
                    }
                    setCheckedRoles({ ...updatedCheckedRoles })
                    return;
                }
                // const afterKeys = getKeysAfter(MerchantRoleList, role)
                if (previousKeys.length > 0 && afterKeys.length === 0) {
                    previousKeys.map((key, i) => {
                        delete updatedCheckedRoles[mainrole][key];
                    })
                }
                delete updatedCheckedRoles[mainrole][role]
                if (Object.keys(updatedCheckedRoles[mainrole]).length === 0) {
                    delete updatedCheckedRoles[mainrole];
                }
                setCheckedRoles({ ...updatedCheckedRoles })
                return;
            }
            let updatedCheckedRoles = { ...checkedRoles };
            const previousKeys = getKeysBefore(MerchantRoleList, role)
            if (!updatedCheckedRoles[mainrole]) {
                updatedCheckedRoles[mainrole] = {};
            }
            if (mainrole === 'Manage Templates') {
                if (role === 'SMS_template_list' || role === 'email_template_list') {
                    updatedCheckedRoles[mainrole][role] = isChecked;
                } else {
                    if (role.includes('SMS')) {
                        updatedCheckedRoles[mainrole][role] = isChecked;
                        updatedCheckedRoles[mainrole]['SMS_template_list'] = isChecked;
                    } else {
                        updatedCheckedRoles[mainrole][role] = isChecked;
                        updatedCheckedRoles[mainrole]['email_template_list'] = isChecked;
                    }
                }
                setCheckedRoles({ ...checkedRoles, ...updatedCheckedRoles });
                return;
            }


            switch (role) {

            case 'change_store_customization': updatedCheckedRoles[mainrole]['store_list'] = isChecked;
                updatedCheckedRoles[mainrole]['update_store'] = isChecked;
                break;
                // case 'send_email':  updatedCheckedRoles[mainrole]['merchant_list'] = isChecked;
                //     break;
            }
            if (previousKeys.length > 0) {
                if (mainrole !== "Other Privileges" && mainrole !== "Manage Settings" && role !== 'change_store_customization') {
                    previousKeys.forEach((key) => {
                        updatedCheckedRoles[mainrole][key] = isChecked;
                    });
                }
            }
            updatedCheckedRoles[mainrole][role] = isChecked;

            setCheckedRoles({ ...checkedRoles, ...updatedCheckedRoles });
            return;
        }
        const isChecked = !checkedRoles[mainrole];
        if (!isChecked) {
            let updatedCheckedRoles = { ...checkedRoles }
            delete updatedCheckedRoles[mainrole];
            setCheckedRoles({ ...updatedCheckedRoles });
            return
        }
        const updatedSubRoles = { [mainrole]: {} };
        MerchantRoleList[mainrole].forEach(subrole => {
            updatedSubRoles[mainrole][subrole] = isChecked;
        });
        setCheckedRoles({ ...checkedRoles, ...updatedSubRoles });
    };
    const handleSelecAll = () => {
        if (selectedMerchantAll) {
            setSelectedMerchantAll(false)
            setCheckedRoles({});

        } else {
            const resultDict = {};
            for (const role in MerchantRoleList) {
                const roleDict = {};
                MerchantRoleList[role].forEach(permission => {
                    roleDict[permission] = true;
                });
                resultDict[role] = roleDict;
            }
            setSelectedMerchantAll(true)
            setCheckedRoles({ ...resultDict });
        }

    }
    function objectToArray(rolesObject) {
        let trueSubRoles = []
        for (const mainRole in rolesObject) {
            if (Object.prototype.hasOwnProperty.call(rolesObject, mainRole)) {
                let subRoles = Object.keys(rolesObject[mainRole]).filter(subRole => rolesObject[mainRole][subRole]);
                // if (subRoles.includes('update_store') || subRoles.includes('update_store_setting')) {
                //     // Push 'update' only if it's not already included
                //     if (!trueSubRoles.includes('update_store')) {
                //         trueSubRoles.push('update_store');
                //     }
                //     if(subRoles.includes('update_store')){
                //         subRoles = subRoles.filter(item => item !== 'update_store');
                //     }else{
                //         subRoles = subRoles.filter(item => item !== 'update_store_setting');
                //     }
                // }
                trueSubRoles.push(...subRoles);

            }
        }
        return trueSubRoles
    }

    useEffect(() => {
        let arr = objectToArray(checkedRoles)
        console.log(checkedRoles, 'checked roles roles checked');
        setstate(prevState => ({
            ...prevState, // Spread previous state
            merchant_privileges: arr // Update or add the new key-value pair
        }));
        if (!compareSelected(checkedRoles)) {
            setSelectedMerchantAll(false)
        } else {
            setSelectedMerchantAll(true);
        }
    }, [checkedRoles])

    function stringConverter(inputString) {
        const words = inputString.split('_');
        const result = words.map(word => {
            if (word.toLowerCase() === 'or') {
                return word.toLowerCase();
            } else {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
        });
        return result.join(' ');
    }

    return (
        <>
            <div className="px-[17px] w-[100%] relative py-4">
                <div className=" custom-checkbox1 relative flex items-center ">
                    <input
                        type="checkbox"
                        className="w-4 cursor-pointer border border-[#9E2064]"
                        id={`merchant-select-all`}
                        data-testid={`merchant-select-all`}
                        checked={selectedMerchantAll || (!employee && Object.keys(checkedRoles).length > 0)}
                        onClick={() => handleSelecAll()}
                        name='checkbox' />
                    <label
                        className="text-[#1F1F1F]  pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                        htmlFor={`merchant-select-all`}>
                        {`${employee ? 'Select All' : 'Login as Merchant'}`}
                    </label>
                </div>
            </div>
            <div data-testid='privilege-div' className="flex flex-wrap mb-6 -mx-[24px] relative">
                {Object.keys(MerchantRoleList).map((mainrole, mainIndex) => (
                    <div className="accordion max-w-[32.733333%] basis-[32.733333%] relative h-[58px] px-[24px]" key={mainrole}>
                        <div className={`border border-[#DDDDDD] w-full rounded-[4px] absolute bg-white`} style={{ width: "-webkit-fill-available", zIndex: 30 - (mainIndex + 1) }}>
                            <div className={`py-4 px-4 border-[#DDDDDD] bg-white`} style={{ width: "-webkit-fill-available", backgroundColor: 'white' }}>
                                <div className='flex justify-between items-center'>
                                    <div className=" custom-checkbox1 relative flex items-center">
                                        <input
                                            type="checkbox"
                                            className="w-4 cursor-pointer border border-[#9E2064]"
                                            id={`main-merchant-checkbox-${mainIndex}`}
                                            data-testid={`main-merchant-checkbox-${mainIndex}`}
                                            checked={checkedRoles[mainrole] || false}
                                            // onChange={() => handleMainCheckboxChange(mainrole)}
                                            onChange={() => {
                                                // toggleAccordion(mainIndex);
                                                handleMainCheckboxChange(mainrole);
                                            }}
                                            name='checkbox' />
                                        <label
                                            className="text-[#1F1F1F] pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                                            // onChange={() => handleMainCheckboxChange(mainrole)}
                                            onChange={() => {
                                                toggleAccordion(mainIndex);
                                                handleMainCheckboxChange(mainrole);
                                            }}
                                            htmlFor={`main-merchant-checkbox-${mainIndex}`}>
                                            {mainrole}
                                        </label>

                                    </div>
                                    <span style={{ float: 'right', cursor: 'pointer' }} data-testid={`merchant-dropdown-${mainIndex}`} onClick={() => toggleAccordion(mainIndex)}>
                                        <img src={`/assets/images/accordion-${openStates[mainIndex]}.svg`} alt="" />

                                    </span>
                                </div>
                                <div className={`accordion-main bg-white w-full ${openStates[mainIndex] && 'border-t border-[#DDDDDD] mt-5'}`}>
                                    {openStates[mainIndex] &&

                                        (MerchantRoleList[mainrole].map((role, i) => (
                                            <div
                                                className={`accordion-content py-4 pl-4 relative  bg-white`}
                                                key={role}
                                            >
                                                <div className=" custom-checkbox1 relative flex items-center ">
                                                    <input
                                                        type="checkbox"
                                                        className="w-4 cursor-pointer border border-[#9E2064]"
                                                        id={`sub-merchant-checkbox-${mainrole}-${i}`}
                                                        data-testid={`sub-merchant-checkbox-${mainIndex}-${i}`}
                                                        checked={checkedRoles?.[mainrole]?.[role] || false}
                                                        onClick={() => handleMainCheckboxChange(mainrole, role)}
                                                        name='checkbox' />
                                                    <label
                                                        className="text-[#1F1F1F] pl-3 text-[16px] leading-[24px] font-normal cursor-pointer "
                                                        htmlFor={`sub-merchant-checkbox-${mainrole}-${i}`}>
                                                        {/* {role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} */}
                                                        {(role => {
                                                            if (role === 'delete_all_cart_products' || role === 'delete_all_reserved_products') {
                                                                return 'Delete All Products';
                                                            } else if (role === 'create_cart_order' || role === 'create_reserved_orde') {
                                                                return 'Create Order';
                                                            } else if (role === 'add_product_cart' || role === 'add_product_reserved') {
                                                                return 'Add Product';
                                                            } else if (role === 'update_store' || role === 'update_store_setting') {
                                                                return 'Update Store';
                                                            } else if (role.includes('activate_or_deactivate')) {
                                                                return stringConverter(role)
                                                            }else if (role === 'send_email_or_SMS') {
                                                                return 'Send Email or SMS';
                                                            }else {
                                                                return role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                                                            }
                                                        })(role)}
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                        ))
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
            </div >
        </>
    )
}
